/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { FiatTokenV1, FiatTokenV1Interface } from '../../FiatTokenV1.sol/FiatTokenV1';

const _abi = [
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [
      {
        name: '',
        type: 'string',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address',
      },
      {
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_name',
        type: 'string',
      },
      {
        name: '_symbol',
        type: 'string',
      },
      {
        name: '_decimals',
        type: 'uint8',
      },
      {
        name: '_masterMinter',
        type: 'address',
      },
      {
        name: '_pauser',
        type: 'address',
      },
      {
        name: '_blacklister',
        type: 'address',
      },
      {
        name: '_owner',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_tokenAddress',
        type: 'address',
      },
    ],
    name: 'reclaimToken',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        name: '',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'unBlacklist',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_from',
        type: 'address',
      },
      {
        name: '_to',
        type: 'address',
      },
      {
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        name: '',
        type: 'uint8',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'masterMinter',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address',
      },
      {
        name: '_addedValue',
        type: 'uint256',
      },
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'unpause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_to',
        type: 'address',
      },
      {
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'mint',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'burn',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newPauser',
        type: 'address',
      },
    ],
    name: 'updatePauser',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'paused',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_address',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        name: '',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_from',
        type: 'address',
      },
    ],
    name: 'lawEnforcementWipingBurn',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'pause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_minter',
        type: 'address',
      },
    ],
    name: 'minterAllowance',
    outputs: [
      {
        name: '',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'owner',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        name: '',
        type: 'string',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'pauser',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_minter',
        type: 'address',
      },
      {
        name: '_decreasedAmount',
        type: 'uint256',
      },
    ],
    name: 'decreaseMinterAllowance',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_spender',
        type: 'address',
      },
      {
        name: '_subtractedValue',
        type: 'uint256',
      },
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_to',
        type: 'address',
      },
      {
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newMasterMinter',
        type: 'address',
      },
    ],
    name: 'updateMasterMinter',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_address',
        type: 'address',
      },
    ],
    name: 'isMinter',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newBlacklister',
        type: 'address',
      },
    ],
    name: 'updateBlacklister',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'blacklister',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_minter',
        type: 'address',
      },
      {
        name: '_increasedAmount',
        type: 'uint256',
      },
    ],
    name: 'increaseMinterAllowance',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_from',
        type: 'address',
      },
      {
        name: '_value',
        type: 'uint256',
      },
      {
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'tokenFallback',
    outputs: [],
    payable: false,
    stateMutability: 'pure',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_owner',
        type: 'address',
      },
      {
        name: '_spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        name: '',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'blacklist',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'isBlacklisted',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'minter',
        type: 'address',
      },
      {
        indexed: true,
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Mint',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'burner',
        type: 'address',
      },
      {
        indexed: false,
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Burn',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'minter',
        type: 'address',
      },
      {
        indexed: false,
        name: 'minterAllowedAmount',
        type: 'uint256',
      },
    ],
    name: 'MinterConfigured',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldMinter',
        type: 'address',
      },
    ],
    name: 'MinterRemoved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newMasterMinter',
        type: 'address',
      },
    ],
    name: 'MasterMinterChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: '_account',
        type: 'address',
      },
    ],
    name: 'Blacklisted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: '_account',
        type: 'address',
      },
    ],
    name: 'UnBlacklisted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newBlacklister',
        type: 'address',
      },
    ],
    name: 'BlacklisterChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [],
    name: 'Pause',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [],
    name: 'Unpause',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newAddress',
        type: 'address',
      },
    ],
    name: 'PauserChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
];

const _bytecode =
  '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';

type FiatTokenV1ConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: FiatTokenV1ConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class FiatTokenV1__factory extends ContractFactory {
  constructor(...args: FiatTokenV1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'FiatTokenV1';
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<FiatTokenV1> {
    return super.deploy(overrides || {}) as Promise<FiatTokenV1>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): FiatTokenV1 {
    return super.attach(address) as FiatTokenV1;
  }
  override connect(signer: Signer): FiatTokenV1__factory {
    return super.connect(signer) as FiatTokenV1__factory;
  }
  static readonly contractName: 'FiatTokenV1';

  public readonly contractName: 'FiatTokenV1';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FiatTokenV1Interface {
    return new utils.Interface(_abi) as FiatTokenV1Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): FiatTokenV1 {
    return new Contract(address, _abi, signerOrProvider) as FiatTokenV1;
  }
}
